import { CellValue, Renderer } from 'react-table'
import { formatDuration } from '../../../../utils/formatUtils'

export function DurationCellRenderer({ value }: CellValue): Renderer<CellValue> | null {
  if (!Number.isFinite(value?.value)) return null

  return formatDuration(value, value.unit)
}
